import { catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { Inject, Injectable, DOCUMENT } from '@angular/core';

import { Settings } from 'src/app/app.settings.model';
import { AppSettings } from 'src/app/app.settings';
import { AbstractService } from '../abstract.service';
import { HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  settings: Settings;

  private window: Window;

  constructor(
    @Inject(DOCUMENT) public document: Document,
    public appSettings: AppSettings,
    public http: HttpClient
  ) {
    this.window = document.defaultView;
    this.settings = this.appSettings.settings;
  }

  redirecionarPara(url: string) {
    this.window.location.href = url;
  }

  redirecionarParaBlank(url: string) {
    this.window.open(url, '_blank');
  }

  public getDataConf(): Observable<any> {
    const urlArquivo = `/assets/data/conf.json`;

    return this.http.get<any>(urlArquivo).pipe(catchError(() => of([])));
  }
  getGrain(grain: string): string {
    switch (grain) {
      case 'milho':
        return 'Milho';
      case 'soja':
        return 'Soja';
      case 'feijao':
        return 'Feijão';
      case 'sorgo':
        return 'Sorgo';
      default:
        return '';
    }
  }

  isZeroOrNull(obj) {
    return obj === undefined || obj == null || Number(obj) === 0;
  }

  isUrl(data: string) {
    return data.toString().indexOf('https://') !== -1 || data.toString().indexOf('http://') !== -1;
  }

  mascaraCNPJ(str) {
    if (str) {
      str = str.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
    return str;
  }
  mascaraCPF(str) {
    if (str) str = str.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    return str;
  }

  stringToQueryParams(queryParamsString: string): object {
    return queryParamsString?.split('&').reduce((acc, param) => {
      const [key, value] = param.split('=');
      return {
        ...acc,
        [key]: value
      };
    }, {});
  }

  relativeTimeThresholdMoment(moment, data: Date) {
    moment.relativeTimeThreshold('s', data.getSeconds());
    moment.relativeTimeThreshold('m', data.getMinutes());
    moment.relativeTimeThreshold('h', data.getHours());
    moment.relativeTimeThreshold('d', data.getDay());
    moment.relativeTimeThreshold('M', data.getMonth());
  }

  transformTextInUrl(str) {
    if (str) {
      return this.removerAcentos(str)
        .replace(/[^\w\s]/gi, '')
        .toLowerCase()
        .replace(/ /g, '-');
    }
    return str;
  }

  removerAcentos(str) {
    let com_acento = 'ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝŔÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿŕ';
    let sem_acento = 'AAAAAAACEEEEIIIIDNOOOOOOUUUUYRsBaaaaaaaceeeeiiiionoooooouuuuybyr';
    let novastr = '';
    for (let i = 0; i < str.length; i++) {
      let troca = false;
      for (let a = 0; a < com_acento.length; a++) {
        if (str.substr(i, 1) == com_acento.substr(a, 1)) {
          novastr += sem_acento.substr(a, 1);
          troca = true;
          break;
        }
      }
      if (troca == false) {
        novastr += str.substr(i, 1);
      }
    }
    return novastr;
  }

  formatarValor(valor: number): string {
    return valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
  }

  groupByKey(collection, property): any[] {
    const groupedCollection: any[] = collection.reduce((previous, current) => {
      if (!previous[current[property]]) {
        previous[current[property]] = [current];
      } else {
        previous[current[property]].push(current);
      }
      return previous;
    }, {});
    return groupedCollection;
  }

  isEbarn(): boolean {
    return environment.nome === 'ebarn';
  }
}
